import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import { AlignLeft, Mail, Link, ListChecks, SquareCheckBig } from 'lucide-react';

const iconMap = {
  short_text: AlignLeft,
  long_text: AlignLeft,
  email: Mail,
  url: Link,
  select: ListChecks,
  checkbox: SquareCheckBig,
  text: AlignLeft,
};

const labelMap = {
  short_text: 'TEXT',
  long_text: 'LONG TEXT',
  email: 'EMAIL',
  url: 'URL',
  select: 'SELECT',
  checkbox: 'CHECKBOX',
  text: 'TEXT',
};

export const FieldTypeIcon = ({ type, size = 16, showLabel = false }) => {
  const Icon = iconMap[type];

  if (!Icon) return null;

  if (showLabel) {
    return (
      <>
        <Box as={Icon} width={size} height={size} aria-hidden="true" sx={{ color: 'text.subtle' }} />
        <Box
          sx={{
            fontSize: '12px',
            fontWeight: '600',
            color: 'text.subtle',
            textTransform: 'uppercase',
            letterSpacing: '1px',
          }}
        >
          {labelMap[type]}
        </Box>
      </>
    );
  }

  return <Box as={Icon} width={size} height={size} aria-hidden="true" sx={{ color: 'text.subtle' }} />;
};

FieldTypeIcon.propTypes = {
  type: PropTypes.oneOf(['text', 'long_text', 'email', 'url', 'select', 'checkbox']).isRequired,
  size: PropTypes.number,
  showLabel: PropTypes.bool,
};

FieldTypeIcon.defaultProps = {
  size: 16,
  showLabel: false,
};
